<script lang="ts">
  import ActionButton from '../ActionButton.svelte';
  import { latestDailyQueryOptions } from '~/lib/queries.svelte';
  import ReplayGameButton from './ReplayGameButton.svelte';
  import { goto } from '$app/navigation';
  import NewDaily from '~/icons/NewDaily.svelte';
  import { getGame, setGame } from '~/store/GameContext.svelte';
  import { getWordsKey } from '~/store/game.svelte';
  import { DailyGame } from '~/store/daily.svelte';
  import { useQueryClient } from '@tanstack/svelte-query';
  import { toast } from 'svelte-sonner';
  import type { DailyPuzzle } from '~/types';
  import { gameOverModal } from '~/routes/[mode=daily_mode]/GameOver.svelte';
  import { page } from '$app/state';

  type Props = {
    newPuzzle: boolean;
  };
  const props: Props = $props();
  const game = $derived(getGame<DailyGame>().current);
  const set = setGame();
  const queryClient = useQueryClient();

  const handlePlayLatest = async () => {
    try {
      const options = latestDailyQueryOptions(game.variant);
      const cached = queryClient.getQueryData<DailyPuzzle>(options.queryKey);
      // The button can show before the cache has rolled over (puzzleExpired).
      // Cached data for the game we just finished is yesterday's puzzle, so
      // force a network fetch instead of reloading it.
      const data =
        cached && cached.id !== game.id
          ? cached
          : await queryClient.fetchQuery({ ...options, staleTime: 0 });
      queryClient.removeQueries({ queryKey: getWordsKey() });
      await game.clear();
      await gameOverModal.pop();
      const targetPath = `/${page.url.pathname.split('/')[1]}`;
      if (!page.url.pathname.endsWith(targetPath)) {
        goto(targetPath, { shallow: true, replace: true });
      } else {
        set(await DailyGame.load(data, false));
      }
    } catch {
      toast.error('failed to load daily puzzle');
    }
  };
</script>

{#if props.newPuzzle}
  <ActionButton onClick={handlePlayLatest}>
    <NewDaily />
    Today's Puzzle
  </ActionButton>
{:else}
  <ReplayGameButton />
{/if}
